<template>
  <div>
    <b-modal ref="settingsmodal" modal-class="tabs-modal" size="lg custom-overlay settingspopup" :hide-footer="true" @show="setIntialState" no-fade>
      <div slot="modal-header" class="w-100">
        <p class="float-left modal-title">Settings</p>
        <b-btn size="lg" class="float-right" variant="flat" @click="closeModal">
          <close-icon class="icon-default close modalclose"></close-icon>
        </b-btn>
      </div>
      <div class="col-md-10">
        <b-tabs pills vertical no-fade class="h-100" @input="tabSelected" v-model="currentTabIndex">
          <b-tab :title="menu.name" v-for="(menu,index) in settingsMenu" :key="menu.name" @click="loadCurrentComponent(menu.component, menu.details)">
            <div v-if="currentTabIndex==index" class="h-100">
              <component class="h-100" :is="currentComponent" :url="menu.location"  :settings="settings" :settingsSubmenu="settingsSubmenu"></component>
            </div>
          </b-tab>
        </b-tabs>
      </div>
    </b-modal>
  </div>
</template>

<script>
import CloseIcon from "../../assets/close.svg";
import AccountSettings from "./AccountSettings";
import AppSettings from "./AppSettings";
import SecuritySettings from "./SecuritySettings";
import EmailSettings from "./EmailSettings";
import CronSettings from "./CronSettings";
import AppUpdateSettings from "./AppUpdateSettings";
import ConnectionMethodSettings from "./ConnectionMethodSettings";
import GoogleSettings from "./GoogleSettings";
import {EventBus} from '../../event/event-bus.js';


export default {
  name: "settings",
  components: {
    CloseIcon,
    AccountSettings,
    AppSettings,
    SecuritySettings,
    EmailSettings,
    CronSettings,
    AppUpdateSettings,
    ConnectionMethodSettings,
    GoogleSettings,
  },
  props:{
    'selectcomponent' : {
        type: String,
        default: ''
      },
  },
  computed: {
    settingsMenu() {
      return this.$store.getters.getSettingsMenu;
    },
    settings() {
      return this.$store.getters.getSettings;
    }
  },
  data() {
    return {
      currentTabIndex: 0,
      currentComponent:'AccountSettings',
      defaultSlugs: [
        'AccountSettings',
        'AppSettings',
        'SecuritySettings',
        'EmailSettings',
        'CronSettings',
        'AppUpdateSettings',
        'ConnectionMethodSettings',
        'GoogleSettings'
      ],
      settingsSubmenu: null
    };
  },
  mounted(){
    EventBus.$on('closeSetting', (data) => {
      this.closeModal();
    })
  },
  methods: {
    setIntialState(){
      this.loadCurrentComponent('AccountSettings');
      if (this.selectcomponent) {
        let menu = _.find(this.settingsMenu, {component: this.selectcomponent })
        this.currentTabIndex = _.findIndex(this.settingsMenu, {component: this.selectcomponent });
        this.loadCurrentComponent(this.selectcomponent);
        this.settingsSubmenu = menu.details;
      }else{
        this.currentTabIndex = _.findIndex(this.settingsMenu, {component: 'AccountSettings' });
        this.loadCurrentComponent('AccountSettings');
      }
    },
    showSettings() {},
    // processAction(payload) {
    //   switch (payload.action) {
    //     case "loginActivity":
    //       this.$router.push({
    //         name: "Manage",
    //         params: { slug: "loginActivity" }
    //       });
    //       this.closeModal();
    //       break;
    //   }
    // },
    closeModal() {
      this.$refs.settingsmodal.hide();
    },
    tabSelected(index) {
      this.currentTabIndex = index;
    },
    loadCurrentComponent(menuSlug, menuDetails){
      if (menuDetails) {
        this.settingsSubmenu = menuDetails;
      }
      if (this.defaultSlugs.indexOf(menuSlug) > -1) {
        this.currentComponent = menuSlug;
      }
      else {
        this.currentComponent = () =>
          this.loadDynamicMenu(menuSlug).then(module => {
            // this.$store.registerModule(slug, module.default.Store);
            return module.default.SettingsMenu;
          });
      }
    },
    loadDynamicMenu(menuSlug){
      switch (menuSlug) {
        case "uptimeMonitor":
          return import(/* webpackChunkName: 'upTimeMonitor/index' */ "@/components/addons/UptimeMonitorUptimeRobot/index");
        case "WPTC":
          return import(/* webpackChunkName: 'WPTC/index' */ "@/components/addons/WPTC/index");
        case "clientPluginBranding":
          return import(/* webpackChunkName: 'ClientPluginBranding/index' */ "@/components/addons/ClientPluginBranding/index");
         case "ScheduleBackup":
          return import(/* webpackChunkName: 'ScheduleBackup/index' */ "@/components/addons/ScheduleBackup/index");
         case "Staging":
          return import(/* webpackChunkName: 'Staging/index' */ "@/components/addons/Staging/index");
        default:
          return Promise.resolve("addon_not_supported");
      }
    }
  
  }
};
</script>

<style scoped>

</style>
